import React, { useEffect, useState } from 'react';
import './Popup.css';
import { supabase } from '../../services/supabase';

interface PopupProps {
  onClose: () => void;
  onDoNotShowToday: () => void;
}

interface NotificationData {
  id: string;
  title: string;
  content: string;
  image_url: string | null;
  enable_hide_today: boolean;
}

const Popup: React.FC<PopupProps> = ({ onClose, onDoNotShowToday }) => {
  const [popupData, setPopupData] = useState<NotificationData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLatestPopup();
  }, []);

  const fetchLatestPopup = async () => {
    try {
      const now = new Date().toISOString();

      console.log('팝업 데이터 조회 시작:', now);

      // 현재 활성화된 팝업 중 가장 최신 것을 가져옴
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('notification_type', 'promotion')
        .order('created_at', { ascending: false })
        .limit(1);

      console.log('팝업 데이터 조회 결과:', { data, error });

      if (error && error.code !== 'PGRST116') {
        // PGRST116은 데이터 없음 (정상)
        console.error('팝업 데이터 가져오기 실패:', error);
      }

      if (data && data.length > 0) {
        const popup = data[0];

        // 날짜 체크 (display_start_date와 display_end_date가 있을 경우에만)
        const shouldShow =
          (!popup.display_start_date || new Date(popup.display_start_date) <= new Date(now)) &&
          (!popup.display_end_date || new Date(popup.display_end_date) >= new Date(now));

        console.log('팝업 표시 여부:', shouldShow, {
          display_start_date: popup.display_start_date,
          display_end_date: popup.display_end_date,
          now
        });

        if (shouldShow) {
          setPopupData(popup);
        }
      }
    } catch (error) {
      console.error('팝업 데이터 가져오기 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  // 데이터 로드 후 팝업이 없으면 부모 컴포넌트에 알림
  useEffect(() => {
    if (!loading && (!popupData || !popupData.image_url)) {
      onClose();
    }
  }, [loading, popupData, onClose]);

  if (loading) {
    return null;
  }

  if (!popupData || !popupData.image_url) {
    return null;
  }

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-btn" onClick={onClose}>
          ✕
        </button>

        <div className="popup-content">
          <img
            src={popupData.image_url}
            alt={popupData.title}
            className="popup-image"
          />
        </div>

        <div className="popup-footer">
          {popupData.enable_hide_today && (
            <button className="popup-dont-show-btn" onClick={onDoNotShowToday}>
              오늘 하루 보지 않기
            </button>
          )}
          <button className="popup-close-footer-btn" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
